import { useAuth } from '@ocula/auth';
import { ReactElement } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { isAuthorisedPathForUser } from './isAuthorisedPathForUser';

export interface AuthorisedRouteProps {
  path: string;
  children: ReactElement;
}

export function AuthorisedRoute({ path, children }: AuthorisedRouteProps) {
  const { organisations } = useAuth();
  const { region, orgName, module } = useParams();
  const orgUrl = organisations[0]?.url;
  const orgAuthorisedRoutes = organisations[0].routes;
  // If path contains the module parameter, then sub in the current value from useParams
  const staticPath = module ? path.replace(':module', module) : path;
  const isAuthorised = isAuthorisedPathForUser(orgAuthorisedRoutes, staticPath);

  if (!orgAuthorisedRoutes || !isAuthorised || orgUrl !== orgName) {
    // TODO: create "contact your admin" or other not-found page to redirect
    // to instead of the org home url if users belong to the org.
    return <Navigate to={orgUrl === orgName ? `/${region}/${orgUrl}` : `/${region}/not-found`} />;
  }

  return children;
}
